interface ITemplateLike {
  priority?: number | null;
  name: string;
}

/**
 * Sorts higher `priority` first (descending); `null`/`undefined` priority is
 * treated as effectively `-Infinity` and sinks to the bottom. Ties (including
 * ties among items with no priority at all) are broken alphabetically by
 * `name` using Czech locale collation.
 */
export function compareTemplates(a: ITemplateLike, b: ITemplateLike): number {
  const priorityA = a.priority ?? -Infinity;
  const priorityB = b.priority ?? -Infinity;

  if (priorityA !== priorityB) {
    return priorityB - priorityA;
  }

  return a.name.localeCompare(b.name, 'cs');
}

/**
 * Returns a NEW, sorted array (never mutates `list`) — see `compareTemplates`
 * for the sort semantics.
 */
export function sortTemplates<T extends ITemplateLike>(list: T[]): T[] {
  return [...list].sort(compareTemplates);
}
